export interface ValidationError {
  field: string;
  message: string;
}

export interface PromoCodeFormData {
  discount_type: 'fixed' | 'percentage';
  discount_value: number | '' | undefined;
  start_date: string;
  end_date: string;
  min_order_amount?: number;
}

/**
 * Validates promo code form data
 * @returns Array of validation errors, empty if valid
 */
export function validatePromoCodeForm(
  formData: PromoCodeFormData,
  isUpdate: boolean = false
): ValidationError[] {
  const errors: ValidationError[] = [];

  // Validate dates
  if (formData.start_date && formData.end_date) {
    const startDate = new Date(formData.start_date);
    const endDate = new Date(formData.end_date);
    
    if (startDate > endDate) {
      errors.push({
        field: 'end_date',
        message: 'The start date must be earlier than or equal to the end date'
      });
    }
  }

  // Validate discount value - required field
  if (formData.discount_value === undefined || formData.discount_value === null || formData.discount_value === 0 || formData.discount_value === '') {
    errors.push({
      field: 'discount_value',
      message: 'The discount value is required and cannot be 0'
    });
  } else {
    // Percentage validation
    if (formData.discount_type === 'percentage') {
      if (formData.discount_value < 0 || formData.discount_value > 100) {
        errors.push({
          field: 'discount_value',
          message: 'The discount percentage must be between 0 and 100'
        });
      }
    }
  }

  return errors;
}

/**
 * Get a user-friendly error message from validation errors
 */
export function getValidationErrorMessage(errors: ValidationError[]): string {
  if (errors.length === 0) return '';
  if (errors.length === 1) return errors[0].message;
  return errors.map(e => e.message).join('; ');
}
